import { getFormGroupLikeWrapper, type WrapperRefs } from '@blaze-runtime/engine-domain';
import { type DataBindingSourceInfo } from '@blaze-shared/elements-domain';

/** The variable a form's newly written row id is assigned to, for the other forms to reference. */
export function formGroupDataSourceVariable(ds: DataBindingSourceInfo): string {
  return `${ds.name?.replaceAll(/[^a-zA-Z0-9]/g, '')}Id`;
}

/** The workflow input a form's rows arrive under; forms sharing a data source are numbered. */
export function formGroupDataSourceInput(
  dataSourceName: string | undefined,
  formId: string,
  refs: WrapperRefs,
): string {
  const index = getFormGroupLikeWrapper(refs).find((entry) => entry.formId === formId)?.index;
  return `form_${dataSourceName?.replaceAll(/[^a-zA-Z0-9]/g, '')}${index ? `_${index}` : ''}`;
}
